class LogicNode
	type: 'logic'

	parse: (info) ->
		type = (info.predicate ? info.logic ? info.type ? '').toLowerCase()
		if info.op?
			items = []
			items.push info.left if info.left?
			items.push info.right if info.right?
			return new (if info.op=='or' then OrNode else AndNode)(items, info.op == 'not')
		else if type == 'and' or type == 'or' or type == 'not'
			items = []
			items.push LogicNode::parse(info.left) if info.left? and info.left != true
			items.push LogicNode::parse(info.right) if info.right? and info.right != true
			items = _.compact items.concat(LogicNode::parse(child) for child in info.items ? [])

			negated = !!info.negated or type == 'not'

			return null if items.length == 0
			return items[0] if items.length == 1 and not negated

			return new (if type == 'or' then OrNode else AndNode)(items, negated)

		type = switch type
			when 'before', 'datelessthan', 'timelessthan' then 'before'
			when 'after', 'dategreaterthan', 'timegreaterthan' then 'after'
			else type

		info = _.extend {}, info

		variable = info.variable ? info.left?.name

		if info.left?.meta?
			# old meta conditions
			variable = switch info.left.meta
				when 'meta_language' then '_language'
				when 'meta_ipaddress' then '_ip_address'
				when 'meta_user' then '_invite_email'
				when 'meta_score' then '_weighted_score'

		info.value = info.value ? info.right

		delete info.variable
		delete info.left
		delete info.right
		delete info.logic
		delete info.type
		delete info.predicate

		return new PredicateNode(variable, type, info)

	format: (survey) ->
		new FormatVisitor(survey).format(this)

	validate: (survey) ->
		new ValidationVisitor(survey).visit(this)

	evaluate: (handler) ->
		new EvaluationVisitor(handler).visit(this)

	serialize: (survey) ->
		new JSONVisitor(survey).visit(this)

	simplify: ->
		new SimplifyVisitor().simplify(this)

class ExprNode extends LogicNode
	type: 'expression'

	constructor: (@left, @right) -> super()

	parse: (info) ->
		switch info.op
			when '+' then return new PlusNode(info.left,info.right)
			when '-' then return new MinusNode(info.left,info.right)
			when '*' then return new TimesNode(info.left,info.right)
			when '/' then return new DivideNode(info.left,info.right)

class PlusNode extends ExprNode
	type: 'plus'

class MinusNode extends ExprNode
	type: 'minus'

class TimesNode extends ExprNode
	type: 'times'

class DivideNode extends ExprNode
	type: 'divide'

class CompareNode extends ExprNode
	type: 'compare'

	parse: (info) ->
		switch info.op
			when '=' then return new ExprEqualsNode(info.left,info.right)
			when '>' then return new ExprGreaterthanNode(info.left,info.right)
			when '<' then return new ExprLessthanNode(info.left,info.right)
			when '>=' then return new ExprGreaterEqualsNode(info.left,info.right)
			when '<=' then return new ExprLessEqualsNode(info.left,info.right)
			when '!=' then return new ExprNotEqualsNode(info.left,info.right)

class ExprEqualsNode extends CompareNode
	type: 'expr_equals'

class ExprGreaterthanNode extends CompareNode
	type: 'expr_greaterthan'

class ExprLessthanNode extends CompareNode
	type: 'expr_lessthan'

class ExprGreaterEqualsNode extends CompareNode
	type: 'expr_greaterequals'

class ExprLessEqualsNode extends CompareNode
	type: 'expr_lessequals'

class ExprNotEqualsNode extends CompareNode
	type: 'expr_notequals'

class ConnectiveNode extends LogicNode
	negated: false
	type: 'connective'
	evaluator: null

	constructor: (@items, @negated=false) -> super()

class AndNode extends ConnectiveNode
	type: 'and'
	evaluator: _.all

class OrNode extends ConnectiveNode
	type: 'or'
	evaluator: _.any

class ArrayNode extends LogicNode
	type:'array'

	constructor: (@id, @start, @end) -> super()

	parse: (info) ->
		new ArrayNode(info.id, info.start, info.end)

class FuncNode extends LogicNode
	type:'func'

	constructor: (@id, @params) -> super()

	parse: (info) ->
		functions =
			'SUM': SumNode
			'MAX': MaxNode
			'MIN': MinNode
			'AVG': AvgNode
			'CONCAT': ConcatNode
			'SUBSTR': SubstrNode
			'INDEXOF': IndexofNode
			'STR': CStrNode
			'INT': CIntNode
			'REAL': CRealNode
			'REALTWO': CRealTwoNode
			'COALESCE': CoalesceNode
		if functions[info.id.value]?
			return new functions[info.id.value](info.id,info.params)
		else
			throw new Error('Function ' + info.id.value + ' doesn\'t exist.')

	visit_func: (initial,visitor) ->
		params = (p for p in @params)
		for param in params.reverse()
			ref = visitor.visit(param)

			value = if ref and ref.value then ref.value() else ref

			# flatten
			if value instanceof Array
				for item in value
					if not visitor.is_empty(item)
						initial = @func item, initial
			else if not visitor.is_empty(value)
				initial = @func value, initial

		return initial

class SumNode extends FuncNode
	type:'func'

	func: (param, sum) ->  EvaluationVisitor::convert_float(param) + sum

	visit: (visitor) -> @visit_func 0, visitor

class MaxNode extends FuncNode
	type:'func'

	func: (param, max) -> if EvaluationVisitor::convert_float(param) > max then EvaluationVisitor::convert_float(param) else max

	visit: (visitor) ->
		result = @visit_func -Infinity, visitor
		if result != -Infinity then result else ''

class MinNode extends FuncNode
	type:'func'

	func: (param, min) -> if EvaluationVisitor::convert_float(param) < min then EvaluationVisitor::convert_float(param) else min

	visit: (visitor) ->
		result = @visit_func Infinity, visitor
		if result != Infinity then result else ''

class AvgNode extends FuncNode
	type:'func'

	func: (param, acc) -> [acc[0] + EvaluationVisitor::convert_float(param), acc[1] + 1]

	visit: (visitor) ->
		[sum, count] = @visit_func [0, 0], visitor
		if count then sum / count else ''

class SubstrNode extends FuncNode
	type:'func'

	visit: (visitor) ->
		if @params.length!=2 and @params.length!=3
			throw new Error("The number of parameters is not correct!")
		params = (p for p in @params)
		params.reverse()
		target = visitor.visit(params[0])
		target = target.label?() ? target
		start = visitor.visit(params[1])
		start = start.value?() ? start
		if params.length>2
			length = visitor.visit(params[2])
			length = length.value?() ? length
		if length then target.substring(visitor.convert_int(start),visitor.convert_int(start)+visitor.convert_int(length)) else  target.substring(visitor.convert_int(start))

class IndexofNode extends FuncNode
	type:'func'

	visit: (visitor) ->
		if @params.length!=2 and @params.length!=3
			throw new Error("The number of parameters is not correct!")
		params = (p for p in @params)
		params.reverse()
		target = visitor.visit(params[0])
		target = target.label?() ? target
		substr = visitor.visit(params[1])
		substr = substr.value?() ? substr
		if params.length>2
			start = visitor.visit(params[2])
			start = start.value?() ? start
		index = if start then target.indexOf(substr,visitor.convert_int(start)) else target.indexOf(substr)

class ConcatNode extends FuncNode
	type:'func'

	func:  (param, acc) ->  acc + param

	visit: (visitor) -> @visit_func '', visitor

class CStrNode extends FuncNode
	type:'func'

	visit: (visitor) ->
		if @params.length!=1
			throw new Error("CStr function only allows one parameter!")
		ref = visitor.visit(@params[0])
		(ref.value?() ? ref).toString()

class CIntNode extends FuncNode
	type:'func'

	visit: (visitor) ->
		if @params.length!=1
			throw new Error("CInt function only allows one parameter!")
		ref = visitor.visit(@params[0])
		value = ref.value?() ? ref
		if isNaN(value)
			throw new Error("The operator is not a number")
		else
			parseInt(value)

class CRealNode extends FuncNode
	type:'func'

	visit: (visitor) ->
		if @params.length!=1
			throw new Error("CReal function only allows one parameter!")
		ref = visitor.visit(@params[0])
		visitor.convert_float(ref.value?() ? ref)

class CRealTwoNode extends FuncNode
	type:'func'

	visit: (visitor) ->
		if @params.length!=1
			throw new Error("CReal function only allows one parameter!")
		ref = visitor.visit(@params[0])

		visitor.convert_float_tofixed_two(ref.value?() ? ref)

class CoalesceNode extends FuncNode
	type:'func'

	func: (param, initial) -> if initial then initial else if not EvaluationVisitor::is_empty(param) then param else ''

	visit: (visitor) -> @visit_func '', visitor

class IndexNode extends LogicNode
	type:'index'

	constructor: (@id, @index) -> super()

	parse: (info) ->
		new IndexNode(info.id, info.index)

class AttrNode extends LogicNode
	type:'attr'

	constructor: (@id, @attr) -> super()

	parse: (info) ->
		new AttrNode(info.id, info.attr)

class IdentifierNode extends LogicNode
	type:'id'

	constructor: (@value) -> super()

	parse: (info) ->
		new IdentifierNode(info.value)

class ConstNode extends LogicNode
	type:'const'

	constructor: (@value) -> super()

	parse: (info) ->
		new ConstNode(info.value)

class PredicateNode extends LogicNode
	type: 'predicate'

	constructor: (@variable, @predicate, @options={}) ->
		super()
		@value = @options.value

	# FIXME: will need to take current page for looped vars
	getVariable: (survey) ->
		return survey.resolveVariable @variable

class LogicVisitor
	###
	Superclass for logic visitors. Calling visitor.visit(node) will
	start a recursive tree walk which can be customized for LogicNode
	subclasses by implementing visitNode_<type>.
	###

	visit: (node, args...) ->
		type = node.constructor
		while type != LogicNode
			if @["visitNode_#{type::type}"]
				return @["visitNode_#{type::type}"](node, args...)
			type = Object.getPrototypeOf(type)
		return @visitNode(node, args...)

	visitNode: (node) -> node

class SimplifyVisitor extends LogicVisitor
	###
	Visitor which performs basic logic simplification:

	* removes nested connectives of the same type
	* (FIXME) reduces predicates using isoneof

	TODO: add a Boolean SAT solver for ultimate nerd points.
	###

	simplify: (node) ->
		# first pass: unwrap unnecessary nesting
		node = @visit node, 1

		# second pass: combine predicates
		#node = @visit node, 2
		#node = @visit node, 3

		return node

	visitNode_connective: (node, state) ->
		# recurse this state for child nodes
		node.items = (@visit(item, state) for item in node.items)

		if state == 1
			# unwrap non-negated subconnectives
			items = []

			for item in node.items
				if item instanceof ConnectiveNode and item.type == node.type and not item.negated
					items = items.concat(item.items)
				else
					items.push item

			node.items = items

		else if state == 2
			# combine multiple "contains" predicates into a single "containsoneof"
			if node.items.length >= 2 and \
			node.type == 'or' and \
			_.all(node.items, (el) -> el.predicate == 'contains' and el.variable == node.items[0].variable)
				node.items = [new PredicateNode(node.items[0].variable, 'containsoneof', value: (el.value for el in node.items))]

		else if state == 3
			# combine multiple "equals" predicates into a single "isoneof"
			if node.items.length >= 2 and \
			node.type == 'or' and \
			_.all(node.items, (el) -> el.predicate == 'equals' and el.variable == node.items[0].variable)
				node.items = [new PredicateNode(node.items[0].variable, 'isoneof', value: (el.value for el in node.items))]

		return node

class ValidationVisitor extends LogicVisitor
	###
	Logic visitor which validates all survey object references.

	Note that this visitor will also update certain types of predicates (in
	particular, yes/no) since we have the survey at this point and can figure
	out variable types.
	###

	constructor: (@survey) -> super()

	visitNode_connective: (node) -> _.all(node.items, (item) => @visit(item))

	visitNode_predicate: (node) ->
		variable = node.getVariable(@survey)

		return false if not variable?

		# Update the variable predicates in place for booleans. We still
		# have the same issue where '0' and '1' are backwards values from
		# the old branching, but now the predicate names are descriptive
		# (no more equals, it's yes/no instead).
		if variable.type == 'boolean' and node.predicate == 'equals'
			if node.options.value == '0'
				node.predicate = 'yes'
			else
				node.predicate = 'no'

			delete node.options.value

		return true

class JSONVisitor extends LogicVisitor
	###
	Visitor which serializes logic into JSON.
	###

	constructor: (@survey) -> super()

	visitNode_connective: (node) ->
		result =
			type: node.type
			items: @visit(item) for item in node.items

		result.negated = true if node.negated

		return result

	visitNode_predicate: (node) ->
		type: node.type
		predicate: node.predicate
		variable: node.getVariable(@survey).id
		value: node.value

class FormatVisitor extends LogicVisitor
	###
	Visitor which formats the logic into a human-readable expression. Accepts
	a config parameter with the following options:

	truncate: <int> | <bool>
	###

	constructor: (@survey, @config={}) ->
		super()
		@predicates = 0

	format: (node) ->
		result = @visit(node)

		if @config.truncate != false
			length = if _.isNumber(@config.truncate) then @config.truncate else 100

			if result.length > length
				result = result.substring(0, length) + "... [#{@predicates} #{gettext('predicates')}]"

		return result

	varLabel: (variable) ->
		###
		Returns a string suitable for identifiying the given variable. Note
		that the argument can either be a Variable instance (in offline mode)
		or an object parsed from server-returned JSON.
		###
		if _.isString variable.label then variable.label else variable.toString()

	choiceLabel: (variable, choice) ->
		###
		Returns the label for a variable choice. This is a bit hacky in order
		to support variables from either formatInfo() in the editor or from offline.
		###
		choices = if _.isFunction variable.choices then variable.choices() else variable.choices
		choice = choices[parseInt(choice, 10)]
		return if _.isString choice then choice else if choice? then choice.label() else '-'

	visitNode_connective: (node, nest=true) ->
		if nest
			result = for child in node.items
				expr = @visit(child, true)
				expr = "(#{expr})" if child instanceof ConnectiveNode
				expr
			result = result.join(" #{node.type.toUpperCase()} ")
			result = "not (#{result})" if node.negated
			return result

		result = switch node.type
			when 'and' then (if node.negated then "not all" else "all")
			when 'or' then (if node.negated then "none" else "any")

		result = "#{result} of the following:"

		for child in node.items
			result += "\n- #{@visit(child, true)}"

		return result

	visitNode_predicate: (node) ->
		@predicates++

		variable = node.getVariable(@survey)

		return "[#{node.variable}]" unless variable?

		if @["visit_#{node.predicate}_#{variable.type}"]?
			return @["visit_#{node.predicate}_#{variable.type}"](variable, node.value)
		else if @["visit_#{node.predicate}"]?
			return @["visit_#{node.predicate}"](variable, node.value)
		else
			throw new Error("predicate '#{node.predicate}' not implemented for type '#{variable.type}'")

	visit_noresponse: (left) -> "#{@varLabel left} has no response"
	visit_hasresponse: (left) -> "#{@varLabel left} has a response"

	visit_nofile: (left) -> "#{@varLabel left} does not have an uploaded file"
	visit_hasfile: (left) -> "#{@varLabel left} has an uploaded file"

	visit_yes_boolean: (left) -> "#{@varLabel left} is yes"
	visit_no_boolean: (left) -> "#{@varLabel left} is no"

	visit_equals: (left, right) -> "#{@varLabel left} = \"#{right}\""
	visit_notequals: (left, right) -> "#{@varLabel left} != \"#{right}\""
	visit_equals_boolean: (left, right) -> "#{@varLabel left} is #{if right == '0' then 'yes' else 'no'}"
	visit_equals_single: (left, right) -> "#{@varLabel left} = \"#{@choiceLabel left, right}\""

	visit_contains_string: (left, right) -> "#{@varLabel left} contains \"#{right}\""
	visit_contains_multi: (left, right) -> "#{@varLabel left} contains \"#{@choiceLabel left, right}\""

	visit_containsoneof_multi: (left, right) -> "#{@varLabel left} contains one of \"#{@choiceLabel left, right}\""
	visit_notcontainsoneof_multi: (left, right) -> "#{@varLabel left} does not contain any of \"#{@choiceLabel left, right}\""

	visit_numberselected_multi: (left, right) -> "#{@varLabel left} has #{parseInt(right, 10)} selected"

	visit_isoneof_single: (left, right) ->
		return "#{@varLabel left} is one of [#{('"' + @choiceLabel(left, el) + '"' for el in right).join(', ')}]"

	visit_notisoneof_single: (left, right) ->
		return "#{@varLabel left} is not one of [#{('"' + @choiceLabel(left, el) + '"' for el in right).join(', ')}]"

	visit_greaterthan_string: (left, right) -> "#{@varLabel left} > #{right}"
	visit_lessthan_string: (left, right) -> "#{@varLabel left} < #{right}"

	visit_after_datetime: (left, right) -> "#{@varLabel left} is after #{right}"
	visit_before_datetime: (left, right) -> "#{@varLabel left} is before #{right}"

class EvaluationVisitor extends LogicVisitor
	###
	Evaluates the logic node with a given handler.

	Predicates are specialized by implementing visit_<predicate> (which implements
	a default for all variable types) and/or visit_<predicate>_<type> (for specific
	predicate/variable type pairs).
	###

	constructor: (@handler) ->
		super()
		if @handler
			@context = @handler.buildContext()
			@survey = @handler.survey
			@response = @handler.response

	visitNode_connective: (node) ->
		result = node.evaluator (@visit(child) for child in node.items), (el) -> !!el
		result = !result if node.negated
		return result


	visitNode_predicate: (node) ->
		variable = node.getVariable(@survey)
		return false unless variable?

		value = @response.values[variable.id]

		if @["visit_#{node.predicate}_#{variable.type}"]?
			result = @["visit_#{node.predicate}_#{variable.type}"](value, node.value, node.options)
			return result;
		else if @["visit_#{node.predicate}"]?
			result = @["visit_#{node.predicate}"](value, node.value, node.options)
			return result
		else
			throw new Error("predicate '#{node.predicate}' not implemented for type '#{variable.type}'")

	visitNode_id:(node) -> @context[node.value]

	visitNode_const:(node) -> node.value

	visitNode_index:(node) ->  @visit(node.id).variables[parseInt(@visit(node.index))]

	visitNode_attr:(node) ->
		ref = @visit(node.id)
		return ref[node.attr.value]?() ? ''

	convert_float: (num) ->
		if isNaN(num)
			throw new Error("The operator is not a number")
		else if typeof(num)!='string' and typeof(num)!='number'
			throw new Error("The operator is not a number")
		else
			parseFloat(num)

	convert_float_tofixed_two: (num) ->
		if isNaN(num)
			throw new Error("The operator is not a number")
		else if typeof(num)!='string' and typeof(num)!='number'
			throw new Error("The operator is not a number")
		else
			parseFloat(num).toFixed(2)

	convert_int: (num) ->
		if isNaN(num)
			throw new Error("The operator is not a number")
		else if typeof(num)!='string' and typeof(num)!='number'
			throw new Error("The operator is not a number")
		else
			parseInt(num)

	is_empty:(value) ->
		value=='None' or value==null or value==undefined or value=='' or ((new trans(value)).toString()=='' if value instanceof Object)

	visitNode_array:(node) ->
		ref = @visit(node.id)
		start =  @visit(node.start) if node.start?
		end =  @visit(node.end) if node.end?
		if start? and end? then ref.slice(start,end) else if start? then ref.row(start) else if end? then ref.col(end) else ref

	visit_binary: (func,node) ->
		left = @visit(node.left)
		right = @visit(node.right)
		func ((left.value?() ? left) || 0), ((right.value?() ? right) || 0)

	visitNode_plus:(node) -> @visit_binary ((left,right) -> EvaluationVisitor::convert_float(left) + EvaluationVisitor::convert_float(right)), node

	visitNode_minus:(node) -> @visit_binary ((left,right) -> EvaluationVisitor::convert_float(left) - EvaluationVisitor::convert_float(right)), node

	visitNode_times:(node) -> @visit_binary ((left,right) -> EvaluationVisitor::convert_float(left) * EvaluationVisitor::convert_float(right)), node

	visitNode_divide:(node) -> @visit_binary ((left,right) -> EvaluationVisitor::convert_float(left) / EvaluationVisitor::convert_float(right)), node

	visitNode_func:(node) -> node.visit(@)

	visitNode_expr_equals:(node) -> @visit_binary ((left, right) -> left.toString() == right.toString()), node

	visitNode_expr_notequals:(node) -> @visit_binary ((left, right) -> left.toString() != right.toString()), node

	visitNode_expr_greaterthan:(node) -> @visit_binary ((left, right) -> if not isNaN(left) and not isNaN(right) then EvaluationVisitor::convert_float(left) > EvaluationVisitor::convert_float(right) else left.toString() > right.toString()),node

	visitNode_expr_lessthan:(node) -> @visit_binary ((left, right) -> if not isNaN(left) and not isNaN(right) then EvaluationVisitor::convert_float(left) < EvaluationVisitor::convert_float(right) else left.toString() < right.toString()),node

	visitNode_expr_greaterequals:(node) -> @visit_binary ((left, right) -> if not isNaN(left) and not isNaN(right) then EvaluationVisitor::convert_float(left) >= EvaluationVisitor::convert_float(right) else left.toString() >= right.toString()),node

	visitNode_expr_lessequals:(node) ->  @visit_binary ((left, right) -> if not isNaN(left) and not isNaN(right) then EvaluationVisitor::convert_float(left) <= EvaluationVisitor::convert_float(right) else left.toString() <= right.toString()),node
	convert_integer: (value) ->
							if value instanceof Array
								new_list = []
								for item in value
									if typeof item == 'string'
										new_list.push parseInt(item, 10)
									else
										new_list.push item
								new_list
							else
								if typeof value == 'string'
									parseInt(value, 10)
	visit_noresponse: (value) -> not value?
	visit_noresponse_string: (value) -> not value?.length
	visit_noresponse_multi: (value) -> not value?.length
	visit_nofile: (value) -> not value?

	visit_hasresponse: (value) -> value?
	visit_hasresponse_multi: (value) -> !!value?.length
	visit_hasfile: (value) -> value?

	visit_yes_boolean: (value) -> value == true
	visit_no_boolean: (value) -> value == false

	visit_equals: (left, right) -> left == right
	visit_notequals: (left, right) -> left != right
	visit_equals_boolean: (left, right) -> left == (right == "0" or right == 0)
	visit_equals_single: (left, right) -> left == parseInt(right, 10)
	visit_equals_multi: (left, right) ->
										left = (left ? [])
										right = (right ? [])
										if left.length == right.length
											right = @convert_integer right
											for i in [0,left.length]
												if left[i]!=right[i]
													false
											true
										else
											false

	visit_contains_string: (left, right) -> left? and left.indexOf(right) >= 0
	visit_contains_multi: (left, right) -> left? and left.indexOf(parseInt(right, 10)) >= 0

	visit_containsoneof_multi: (left, right) ->
											right = @convert_integer (right ? [])
											intersection =  (left ? []).filter (n) ->
												if (right.indexOf n)== -1
													return false
												return true
											intersection.length > 0

	visit_notcontainsoneof_multi: (left, right) ->
											right = @convert_integer (right ? [])
											intersection =  (left ? []).filter (n) ->
												if (right.indexOf n) == -1
													return false
												return true
											intersection.length == 0


	visit_numberselected_multi: (left, right) -> (left ? []).length == parseInt(right, 10)

	visit_isoneof_single: (left, right) ->
										right = @convert_integer (right ? [])
										(right ? []).indexOf(left) >= 0
	visit_notisoneof_single: (left, right) ->
										right = @convert_integer (right ? [])
										(right ? []).indexOf(left) == -1

	visit_greaterthan_string: (left, right) -> parseFloat(left, 10) > parseFloat(right, 10)
	visit_lessthan_string: (left, right) -> parseFloat(left, 10) < parseFloat(right, 10)

	visit_after_datetime: (left, right) -> left? and right? and left > right
	visit_before_datetime: (left, right) -> left? and right? and left < right

class SurveyFinishException extends Error then constructor: -> super()

class SurveyTerminateException extends Error then constructor: -> super()

class SurveyRedirectException extends Error then constructor: -> super()

class SurveyAction
	type: undefined
	label: undefined

	###
	Whether this action is a branching action (i.e. final). If a rule has multiple actions, only
	the first branching action applies.
	###
	isBranch: false

	###
	Whether this action has targets (hide/show/disable rules). These actions need to be handled
	by their targets rather than the source page.
	###
	hasTargets: false

	format: (survey) -> @label

	validate: (survey) -> true

	serialize: (survey) ->
		type: @type

class BranchAction extends SurveyAction
	isBranch: true

class PageBranchAction extends BranchAction
	type: 'skip'
	label: gettext('skip to page')

	constructor: (@page) -> super()

	apply: (survey) -> (survey.pageMapping ? survey.pages)[@page]

	format: (survey) -> interpolate(gettext('skip to %(page)s'), page: (survey.pageMapping ? survey.pages)[@page].page)

	validate: (survey) -> @page of (survey.pageMapping ? survey.pages)

	serialize: (survey) ->
		# NOTE: we don't convert from pageIDs here because then we won't
		# be able to reload the branching logic. Conversion gets done on
		# survey save instead
		_.extend super(arguments...), page: @page #page: (survey.pageMapping ? survey.pages)[@page].index

class FinishBranchAction extends BranchAction
	type: 'finish'
	label: gettext('complete the form')

	apply: (survey) -> throw new SurveyFinishException()

class TerminateBranchAction extends BranchAction
	type: 'terminate'
	label: gettext('terminate the form')

	apply: (survey) -> throw new SurveyTerminateException()

class RedirectBranchAction extends BranchAction
	type: 'redirect'
	label: gettext('redirect to a URL')

	constructor: (@url) -> super()

	apply: (survey) -> # don't redirect in offline mode

	format: (survey) -> interpolate(gettext('redirect to %(url)s'), url: @url)

	serialize: -> _.extend super(arguments...),
		url: @url

class ContinueAction extends BranchAction
	type: 'continue'
	label: gettext('skip to the next loop iteration')

class RandomBranchAction extends PageBranchAction
	type: 'random'
	label: gettext('skip to a random page')

	format: (survey) ->
		interpolate(gettext('skip to %(pages)s'), {pages:@pages})

	constructor: (@pages) -> super(pages)

	validate: (survey) ->
		_.all @pages.split(','), (n) ->
			return parseFloat(n) && isFinite(n) && n < survey.pages.length

	serialize: ->
		pages: @pages,
		type: @type

class RandomRangeAction extends BranchAction
	type: 'random-range'
	label: gettext('randomly traverse a page range')

	constructor: (@pages, @after) -> super()

	serialize: -> _.extend super(arguments...),
		pages: @pages
		after: @after

# TargetActions are ones that, instead of branching to a different page, change
# the behavior of "target" questions/variables on the page.
class TargetAction extends SurveyAction
	hasTargets: true

	# targets a row in a grid: "question_id[row:]"
	ROW_RE: /^([-a-zA-Z0-9]+)\[(.+?):\]$/
	# targets a column in a grid: "question_id[:column]"
	COLUMN_RE: /^([-a-zA-Z0-9]+)\[:(.+?)\]$/

	constructor: (@target, @exclude) ->
		super()
		if (match = @ROW_RE.exec(@target))?
			@target = match[1]
			@row = parseInt(match[2], 10)
		else if (match = @COLUMN_RE.exec(@target))?
			@target = match[1]
			@column = parseInt(match[2], 10)

	getElSelector: ->
		if @row?
			".x_#{escapeSelector @target}_#{@row}"
		else if @column?
			".x_#{escapeSelector @target}__#{@column}"
		else
			"#x_#{escapeSelector @target}"

	getTargetId: ->
		if @row?
			"#{@target}[#{@row}:]"
		else if @column?
			"#{@target}[:#{@column}]"
		else
			@target

	getTargetLabel: (survey) ->
		question = survey.questions[@target]
		if @row? and question?.rows?
			return question.rows[@row].text
		else if @column? and question?.types?
			return question.types[@column].text
		else if question?
			return question.label
		else if @target of survey.variables
			return survey.variables[@target].label

	apply: (matches, el) ->

	validate: (survey) -> @getTargetLabel(survey)?

	serialize: -> _.extend super(arguments...),
		target: @getTargetId()

class HideAction extends TargetAction
	type: 'hide'
	label: gettext('hide a question')

	apply: (matches, el) ->
		if matches
			el.find(@getElSelector()).addClass 'hidden'
		else
			el.find(@getElSelector()).removeClass 'hidden'

	format: (survey) ->
		t = @getTargetLabel(survey)
		return interpolate(gettext('hide %(target)s'), {target: t}, true)

class ShowAction extends TargetAction
	type: 'show'
	label: gettext('show a question')

	apply: (matches, el) ->
		if matches
			el.find(@getElSelector()).removeClass 'hidden'
		else
			el.find(@getElSelector()).addClass 'hidden'

	format: (survey) -> interpolate(gettext('show %(target)s'), {target: @getTargetLabel(survey)}, true)

class DisableAction extends TargetAction
	type: 'disable'
	label: gettext('disable a question')

	apply: (matches, el) ->
		inputs = el.find(@getElSelector()).find(':input')

		inputs = inputs.filter(":not([name=#{@exclude}])") if @exclude

		inputs.prop('disabled', matches)

	format: (survey) -> interpolate(gettext('disable %(target)s'), {target: @getTargetLabel(survey)}, true)

class InvalidAction extends TargetAction
	type: 'mark-invalid'
	label: gettext('mark as an invalid question')
	constructor: (target, feedback) ->
		super target
		@feedback = feedback
		@target = target

	format: (survey) -> interpolate(gettext('mark %(target)s as an invalid question'), target: @getTargetLabel(survey))

	serialize: -> _.extend super(arguments...),
		feedback: @feedback

class HidePageAction extends SurveyAction
	type: 'hide-page'
	label: gettext('hide a page')

	constructor: (@page) -> super()

	getPage: (survey) -> (survey.pageMapping ? survey.pages)[@page]

	format: (survey) -> interpolate(gettext('hide page %(page)s'), page: (survey.pageMapping ? survey.pages)[@page].page)

	validate: (survey) -> @page of (survey.pageMapping ? survey.pages)

	serialize: (survey) ->
		# NOTE: we don't convert from pageIDs here because then we won't
		# be able to reload the branching logic. Conversion gets done on
		# survey save instead
		_.extend super(arguments...), page: @page #page: (survey.pageMapping ? survey.pages)[@page].index

class MarkCompleteAction extends SurveyAction
	type: 'mark-complete'
	label: gettext('mark the response as completed')

class EmailAction extends SurveyAction
	type: 'email'
	label: gettext('send an email')

	constructor: (@settings) -> super()

	serialize: -> _.extend super(arguments...), @settings

SurveyAction.TYPES = {}

for cls in [TargetAction
	PageBranchAction, FinishBranchAction, TerminateBranchAction, RedirectBranchAction,
	ContinueAction, RandomBranchAction, RandomRangeAction, HideAction, ShowAction, DisableAction, InvalidAction,
	HidePageAction, MarkCompleteAction, EmailAction]
	SurveyAction.TYPES[cls::type] = cls

class BranchingRule
	constructor: (@condition, @actions...) ->

	parseAction: (info) ->
		switch info.type ? info.skip
			when 'mark-complete' then new MarkCompleteAction()
			when 'redirect' then new RedirectBranchAction(info.url ? info.redirect)
			when 'hide' then new HideAction(info.target ? info.hideQuestion)
			when 'show' then new ShowAction(info.target ? info.showQuestion)
			when 'disable' then new DisableAction(info.target ? info.disableVariable)
			when 'mark-invalid' then new InvalidAction(info.target, info.feedback)
			when 'hide-page' then new HidePageAction(info.page)
			when 'finish' then new FinishBranchAction()
			when 'terminate' then new TerminateBranchAction()
			when 'random' then new RandomBranchAction(info.pages ? info.pageRange)
			when 'random-range' then new RandomRangeAction(info.pages ? info.pageRange, info.after ? info.skipToPage)
			when 'email' then new EmailAction(info.emailsettings ? info)
			when 'skip' then new PageBranchAction(info.page)
			when 'continue' then new ContinueAction()
			else new PageBranchAction(info.skip)

	parse: (info) ->
		condition = LogicNode::parse(info.condition).simplify()

		# info.skip is for compatibility purposes (old format)
		if info.skip?
			actions = [BranchingRule::parseAction(info)]
		else if info.action?
			actions = [BranchingRule::parseAction(info.action)]
		else if info.actions?
			actions = (BranchingRule::parseAction(action) for action in info.actions)
		else
			return null

		return new BranchingRule(condition, actions...)

	validate: (survey) ->
		@condition.validate(survey) and _.all(@actions, (action) -> action.validate(survey))

	format: (survey) ->
		actions = (action.format(survey) for action in @actions).join(', ')

		return "If #{@condition.format(survey)} then #{actions}"

	serialize: (survey) ->
		result =
			condition: @condition.serialize(survey)

		if @actions.length == 1
			result.action = @actions[0].serialize(survey)
		else
			result.actions = (action.serialize(survey) for action in @actions)
		return result

	parseSimple: (question, rules) ->
		for rule in rules ? []
			condition = new PredicateNode(question.id, 'equals', value: rule.val)
			action = switch rule.page
				when 'finish' then new FinishBranchAction()
				when 'terminate' then new TerminateBranchAction()
				else new PageBranchAction(rule.page)

			new BranchingRule(condition, action)

module.exports = {
	LogicNode, OrNode, PredicateNode, SurveyFinishException, SurveyTerminateException, SurveyRedirectException, SurveyAction, EvaluationVisitor,
	DisableAction, BranchingRule, InvalidAction, HidePageAction, ExprNode, CompareNode, ConnectiveNode, ArrayNode,FuncNode,IndexNode,AttrNode,IdentifierNode,ConstNode
}
